import { Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

interface NextActionProps {
  label: string;
  to: string;
}

export default function NextAction({ label, to }: NextActionProps) {
  return (
    <Box sx={{ mt: 5, mr: 2, textAlign: "right" }}>
      <Link component={RouterLink} to={to}>
        {label}
      </Link>
    </Box>
  );
}
